var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-badge',{class:_vm.classes,attrs:{"size":_vm.size,"label":_vm.getDisplayedPlan(_vm.plan),"transferLicenseFrom":_vm.transferLicenseFrom}})
}
var staticRenderFns = []

export { render, staticRenderFns }